/**
 * Assigns the node to all the refs passed in the argument.
 *
 * Overview + use case: https://www.loom.com/share/b6a77cda2fad46be9641187e18c820ea
 *
 * @param refs: An array of refs (as function or ref object)
 */
export const mergeRefs = function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null && ref !== undefined) {
        ref.current = value;
      }
    });
  };
};